import Dbm from "dbm";
import Website from "../../../index.js";

export default class Table extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);

        this.item.requireProperty("originalInertia", 0);
        
        let mainBody = Matter.Bodies.rectangle(0, 0, 127, 38, {
            label: "table",
            restitution: 0,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE, Website.game.PhysicsGroups.TABLE_INTERACTIONS)
        });

        /*
        let leftLeg = Matter.Bodies.rectangle(-64, 17, 5, 34, {
            label: "table",
            restitution: 0,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE, Website.game.PhysicsGroups.TABLE_INTERACTIONS)
        });

        let rightLeg = Matter.Bodies.rectangle(64, 17, 5, 34, {
            label: "table",
            restitution: 0,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE, Website.game.PhysicsGroups.TABLE_INTERACTIONS)
        });
        */

        let body = Matter.Body.create({
            parts: [mainBody],
            label: "table-compound",
            restitution: 0,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE, Website.game.PhysicsGroups.TABLE_INTERACTIONS)
        });

        this.item.originalInertia = body.inertia;
        Matter.Body.setInertia(body, Infinity);

        this.item.setValue("physicsBody", body);
    }

    update(aTime, aDelta) {

        let groundPosition = Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+10;
        let graphicsHeight = 50;
        let physicsHeight = 38;
        let basePosition = groundPosition + 0.5*(physicsHeight-graphicsHeight)

        this.item.pixiLayer.x = this.item.physicsBody.position.x;
        this.item.pixiLayer.y = this.item.physicsBody.position.y+basePosition;

        this.item.pixiLayer.rotation = this.item.physicsBody.angle;
    }
}